import React from "react";
import classNames from "classnames";

const STEP_STATUS = {
  COMPLETED: "Completed",
  IN_PROGRESS: "In Progress",
  INCOMPLETE: "Incomplete",
};

const STATUS_CLASS_NAMES = {
  [STEP_STATUS.COMPLETED]: "completed",
  [STEP_STATUS.IN_PROGRESS]: "in-progress",
  [STEP_STATUS.INCOMPLETE]: "incomplete",
};

export type StepStatusType = "Completed" | "In Progress" | "Incomplete";

export interface StepData {
  label: string;
  status: StepStatusType;
}

interface Props {
  data: StepData;
  handleClick?: (ev: React.MouseEvent<HTMLDivElement>) => void;
  stepNum: number;
  solid?: boolean;
}

const StepItem: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    data: { label, status = STEP_STATUS.INCOMPLETE },
    stepNum,
    solid,
    handleClick,
  } = props;

  const itemClasses = classNames("caprx-step-item", `caprx-step-item-${STATUS_CLASS_NAMES[status]}`);

  let stepLabel = label;
  if (!solid) {
    stepLabel = status;
  }

  // Only allow click handler on completed steps
  let handleClickWhenValid = null;
  // Show a check mark instead of a step number when completed
  let stepNumContent = stepNum.toString(10);
  let stepNumClassList = "";

  if (status === STEP_STATUS.COMPLETED) {
    stepNumContent = "";
    stepNumClassList = "caprx-icon-input-check";
    handleClickWhenValid = handleClick;
  }

  return (
    <div className={itemClasses} onClick={handleClickWhenValid}>
      <div className="caprx-step-item-status-box">
        <span className={stepNumClassList}>{stepNumContent}</span>
      </div>
      <div className="caprx-step-item-labelstatus">
        <div className="caprx-step-item-label">{stepLabel}</div>
        <div className="caprx-step-item-status">{status}</div>
      </div>
    </div>
  );
};

export default StepItem;
